module.exports = __webpack_public_path__ + "static/img/video_poster.95910fe.png";